var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainPage',{attrs:{"title":_vm.$t('mainPage'),"subtitle":_vm.$t('mainPageSubTitle')}},[_c('v-row',[_c('v-col',{staticClass:"col-8"},[_c('Licenses')],1),_c('v-col',{staticClass:"col-4"},[_c('Profile',{staticClass:"mb-6"}),_c('Payment',{staticClass:"mb-6"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }